import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import Input from '../../../components/elements/Input';
import Title2 from '../../../components/elements/Title2';
import Button from '../../../components/elements/Button';
import { useParams } from 'react-router-dom';
import { add, getTipsByChallengeId, deleteTipsById, setTips } from '../../../slices/tipsSlice';
import { FaTrashCan } from "react-icons/fa6";
import Swal from 'sweetalert2';

const AddTips = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { tips, message, loading, error } = useSelector((state) => state.tips);
  const [tipsCreated, setTipsCreated] = useState("");
  const [tip, setTip] = useState("");
  const [showMessageSuccess, setShowMessageSuccess] = useState(false);

  // Carrega as dicas do desafio ao montar o componente
  useEffect(() => {
    dispatch(getTipsByChallengeId(id));
  }, [dispatch, id]);

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Tem certeza?',
      text: "Você não poderá reverter esta ação!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sim, excluir!',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteTipsById(id));

        const updatedTips = tips.filter(tip => tip._id !== id); // Filtra a dica excluída

        // Atualiza o estado de dicas no Redux
        dispatch(setTips(updatedTips));

        Swal.fire('Excluído!', 'O item foi excluído com sucesso.', 'success');
      }
    });
  };

  // Manipula o envio do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();

    const tipsData = {
      challengeId: id,
      content: tip,
    };

    const res = await dispatch(add(tipsData));

    if (!res.error) {
      setTip(""); // Limpa o campo após adicionar
      dispatch(getTipsByChallengeId(id)); // Atualiza a lista de dicas
      setShowMessageSuccess(true); // Exibe mensagem de sucesso
    }
  };

  return (
    <>
      <motion.div
        className="basis-1/4 bg-verde-oliva border-verde-musgo bg-opacity-85 sm:rounded-lg content-center border-solid shadow-md rounded p-3 m-3 max-w-96 max-h-fit hover:resize"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <form className="mt-10" onSubmit={handleSubmit}>
          <Input
            placeholder="Pista"
            onChange={setTip}
            label={"Adicione uma pista por vez"}
            font="font-special text-red"
            value={tip}
          />
          {!loading && (
            <input
              type="submit"
              className="font-special font-semibold transition ease-in-out delay-150 duration-300 hover:-translate-y-1 hover:scale-110 text-white bg-bordo hover:bg-bordo-600 focus:outline-none focus:ring-bege-cl-300 font-medium rounded-full text-sm w-full sm:w-40 px-5 py-2.5 text-center"
              value="Adicionar"
            />
          )}
          {loading && <Button propertiesButton={{type: "submit", dis: "disabled", desc: "Aguarde..."}} />}
        </form>
        <div>
          <Title2 tit="Dicas cadastradas" model="def" />
          <ul>
            {tips && tips.length > 0 ? (
              tips.map((tp, index) => (
                <li key={index}>
                  <span  className="font-special bg-green text-white p-2 font-semibold float-left ml-3 mt-1 rounded-full mr-2">
                    {tp.content} <FaTrashCan  onClick={() => handleDelete(tp._id)} style={{fontSize: "12px", float: "right", marginLeft: "5px", marginTop: "5px", color: "#c53030"}}/>
                  </span>
                </li>
              ))
            ) : (
              <p className="font-special text-white">Nenhuma dica registrada.</p>
            )}
          </ul>
        </div>
      </motion.div>
    </>
  );
};

export default AddTips;
